<template>
    <div>
      <van-nav-bar
        :title="$t('app.activitydetail.title')"
        :left-text="$t('app.common.back')"
        left-arrow
        @click-left="$router.push('/activity')"
      />
      <div v-html="content" class="content">

      </div>
    </div>
</template>

<script>
    export default {
      name: "ActivityDetail",
      data(){
        return{
          content:''
        }
      },
      methods:{
        getActivityDetail(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "POST",
              data: {
                'nozzle': 'active_activity',
                'activityid': that.$route.query.activityid,
                type:1
              }
            })
            .then(ret => {
              let resData = ret.data;
              // console.log(resData);
              if (resData.code === 1){
                that.content = resData.data;
                that.content = that.content.replace("http://wonder.apps/recharge", " #/member/recharge");
                that.content = that.content.replace("http://wonder.apps/withdraw","#/member/withdrawal");
                that.content = that.content.replace("http://wonder.apps/realname_auth","#/member/information/real_name");
                that.content = that.content.replace("http://wonder.apps/register","#/registered");
                that.content = that.content.replace("http://wonder.apps/login","#/login");
                that.content = that.content.replace("http://wonder.apps/trading","#/activity/activity_detail?activityid=20");
              }else{
                that.$toast.fail(that.$t(resData.msg));
              }
            });
        }
      },
      mounted: function () {
        let that = this;
        this.getActivityDetail();
      },
    }
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}
  .content{
    width: 100%;
  }
  .content>>>img{
    width: 100%;
  }
  .content>>>p{
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/ActivityDetail.vue